import asyncParallel from 'async/parallel';
import asyncEachLimit from 'async/eachLimit';
import { ethers } from 'ethers';
import EthTools from './eth_tools';
import ERC20_ABI from './erc20.json';

const ZERO = '0x0000000000000000000000000000000000000000';
const ERC20_INTERFACE = new ethers.utils.Interface(ERC20_ABI);
const BLOCK_LIMIT = 5;

export default {
  fetchDetails,
  balanceOf,
  allowance,
  approve,
  transfer,
  getLogs,
};

function fetchDetails(params, done) {
  const contract = _getContract(params);
  let name = '';
  let symbol = '';
  let decimals = '';
  asyncParallel(
    [
      (done) => {
        contract.name().then(
          (result) => {
            name = result;
            done();
          },
          () => done()
        );
      },
      (done) => {
        contract.symbol().then(
          (result) => {
            symbol = result;
            done();
          },
          () => done()
        );
      },
      (done) => {
        contract.decimals().then(
          (result) => {
            decimals = result;
            done();
          },
          () => done()
        );
      },
    ],
    () => {
      const details = { name, symbol, decimals };
      done(null, details);
    }
  );
}

function balanceOf(params, done) {
  const { chain_id, owner } = params;
  if (params.contract_addr === ZERO) {
    const provider = EthTools.getProvider(chain_id);
    provider.getBalance(owner).then((balance) => done(null, balance), done);
  } else {
    const contract = _getContract(params);
    contract.balanceOf(owner).then((balance) => done(null, balance), done);
  }
}
function allowance(params, done) {
  const { owner, spender } = params;
  const contract = _getContract(params);
  contract.allowance(owner, spender).then((value) => {
    done(null, value);
  }, done);
}
function approve(params, done) {
  const { chain_id, spender, value } = params;
  const contract = _getContract(params);
  contract.populateTransaction.approve(spender, value).then(
    (tx) => {
      tx.chainId = chain_id;
      done(null, tx);
    },
    (err: any) => done(err)
  );
}
function transfer(params, done) {
  const { chain_id, to, value } = params;
  const contract = _getContract(params);
  contract.populateTransaction.transfer(to, value).then(
    (tx) => {
      tx.chainId = chain_id;
      done(null, tx);
    },
    (err: any) => done(err)
  );
}
function getLogs(params, done) {
  const { chain_id, address } = params;
  const contract = _getContract(params);
  const out_filter = contract.filters.Transfer(address);
  const in_filter = contract.filters.Transfer(null, address);
  const result_list = [];
  asyncParallel(
    [
      (done) => _query(contract, result_list, out_filter, done),
      (done) => _query(contract, result_list, in_filter, done),
    ],
    () => {
      result_list.sort(EthTools.sortLogs);
      result_list.forEach((result) => {
        result.type = result.args.from === address ? 'send' : 'receive';
        result.value_eth = EthTools.toEthValue(result.args.value);
      });
      asyncEachLimit(
        result_list,
        BLOCK_LIMIT,
        (result, done) => {
          const opts = { chain_id, block_number: result.blockNumber };
          EthTools.getBlockTimestamp(opts, (err, timestamp) => {
            if (!err && timestamp) {
              result.timestamp = timestamp;
              result.timestamp_date = new Date(timestamp * 1000);
              const options = {
                weekday: 'short',
                year: 'numeric',
                month: 'short',
                day: 'numeric',
              };
              result.date = result.timestamp_date.toLocaleDateString(
                undefined,
                options
              );
              result.time = result.timestamp_date.toLocaleTimeString();
            }
            done(null);
          });
        },
        () => {
          done(null, result_list);
        }
      );
    }
  );
}
function _query(contract, result_list, filter, done) {
  contract.queryFilter(filter).then(
    (results) => {
      results.forEach((result) => result_list.push(result));
      done();
    },
    () => done()
  );
}
function _getContract(params) {
  const { chain_id, contract_addr } = params;
  const provider = EthTools.getProvider(chain_id);
  const contract = new ethers.Contract(
    contract_addr,
    ERC20_INTERFACE,
    provider
  );
  return contract;
}
